import { useContext, useEffect, useState } from 'react';

import {
  STUDIO_CLIENT_PREVIEW_PARAM,
  STUDIO_CLIENT_PREVIEW_VALUE,
} from 'src/constants/studioFtux';
import { RouteContext } from 'src/context';
import history from 'src/history';

/**
 * True while the current session is a Studio "test as a client" preview — the
 * landing URL carries `studioClientPreview=true` (minted by the CRM "Test as a
 * client" link). The intent is captured into ephemeral component state so the
 * client-side "Getting started" card shows during the preview only.
 *
 * The flag lives in `useState` (not persisted), so a full refresh clears it; the
 * param is stripped from the URL on capture so a refresh can't re-set it. Client
 * navigation within the session keeps the flag because AppShell persists the
 * sidebar tree across route transitions.
 */
export const useStudioClientPreview = (): boolean => {
  const { query } = useContext(RouteContext);
  const [isStudioClientPreview, setIsStudioClientPreview] = useState(false);

  useEffect(() => {
    if (query[STUDIO_CLIENT_PREVIEW_PARAM] !== STUDIO_CLIENT_PREVIEW_VALUE) {
      return;
    }
    setIsStudioClientPreview(true);
    const params = new URLSearchParams(history.location.search);
    params.delete(STUDIO_CLIENT_PREVIEW_PARAM);
    history.replace({ search: params.toString() });
  }, [query]);

  return isStudioClientPreview;
};
